/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { View, type ViewStyle } from 'react-native';
import { styles } from '../ReportsScreen.styles';

type Props = {
  children: React.ReactNode;
  style?: ViewStyle;
  bodyStyle?: ViewStyle;
  /** Período contextual en accesibilidad (p. ej. si el título viene del padre). */
  accessibilityLabel?: string;
};

/**
 * Mismo cromo que la card densa (borde, fondo) sin franja de acento.
 * Para secciones que contienen varias `ReportsDenseListCard` o filtros + listas.
 */
export function ReportsDenseSectionShell({ children, style, bodyStyle, accessibilityLabel }: Props) {
  return (
    <View style={[styles.reportsDenseSectionShell, style]} accessibilityLabel={accessibilityLabel}>
      <View style={[styles.reportsDenseSectionShellBody, bodyStyle]}>{children}</View>
    </View>
  );
}
